import { render, staticRenderFns } from "./IconSvgInfo.vue?vue&type=template&id=010251d2&scoped=true&"
import script from "./IconSvgInfo.vue?vue&type=script&lang=js&"
export * from "./IconSvgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010251d2",
  null
  
)

export default component.exports